import React from 'react';
import { useTenantId } from '@fluentsms/auth';
import { SubscriptionChannel } from '@fluentsms/lib-subscriptions';
import { createEventContext, EventContextProvider } from '../EventContextProvider';

export const OrderEventContext = createEventContext();

export const OrderEventContextProvider: React.FC<{ children: React.ReactNode; orderId: string; branchId: string }> = ({
  children,
  orderId,
  branchId,
}) => {
  const tenantId = useTenantId();
  const channel: SubscriptionChannel | null = orderId ? { context: 'order', orderId, tenantId, branchId } : null;
  return (
    <EventContextProvider channel={channel} context={OrderEventContext}>
      {children}
    </EventContextProvider>
  );
};
